import { arrayUtils } from '@sato/components';
import { IntlMessageFormat, PrimitiveType } from 'intl-messageformat';

import { LanguageKey } from '@models/Language';
import { isLocalOrTestEnv } from '@utils/featureFlags';

export const formatTranslation = (
  translation: string,
  formatProps: Record<string, PrimitiveType>,
  language: LanguageKey
) => {
  try {
    const formatted = new IntlMessageFormat(translation, language).format(
      formatProps
    );

    // stringify array return value
    return Array.isArray(formatted)
      ? arrayUtils.joinArrayString(
          formatted.map((x) => x?.toString()),
          ''
        )
      : (formatted?.toString() ?? '?');
  } catch (e) {
    if (isLocalOrTestEnv) {
      console.error(e);
    }

    return '?';
  }
};
